<div class="confirmDialog">
    <div style="padding: 10px">
        <h1 mat-dialog-title>{{data.title}}</h1>
        <mat-dialog-content>
            <pre>{{data.content | json}}</pre>
        </mat-dialog-content>
        <div mat-dialog-actions align="center">
            @if(data.actionName && data.actionReturns) {
                <button mat-raised-button color='warn' (click)="takeAction()">{{data.actionName}}</button>
            }
            <button mat-raised-button [mat-dialog-close]="true">close</button>
        </div>
    </div>
</div>
